<footer class="ezee-footer">
  <div class="container-fluid footter">
    <div class="quick-links d-flex">

      <ul class="img-card">
        <li>
       <img class="logo-white" src="assets/Images/logo.png" height="40px" width="auto"><br />

          <div>
            <p style="color:white;">Copyright © 2025 Zenithguard</p>

          </div>
        </li>
       

      </ul>
      <ul>
        <li>
          <a [routerLink]="['/Refunds']">

            <span>Refund & Cancellation Policy</span>
          </a>

        </li>
        <li>
          <a [routerLink]="['/TermsAndCondition']">
            <span>Term & Conditions</span>
          </a>

        </li>
        <li>
          <a [routerLink]="['/PrivacyPolicy']">
            <span>Privacy Policy</span>
          </a>

        </li>

      </ul>

    </div>
    
  </div>
</footer>


